module.exports = __webpack_public_path__ + "images/apps/shimo-text-e0255fd692724b2576410abc8e00de9f.png";